var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-text",style:({'color': _vm.textColor})},[_c('el-icon',{staticClass:"el-icon-warning-outline"}),_c('span',[_vm._v(" "+_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }